import { defineMessages } from 'react-intl';
import { SEO } from 'packages/theming/brands';

const seo: SEO = defineMessages({
  pageTitle: {
    id: '',
    description: 'Page title',
    defaultMessage: '{routeTitle} on Stir',
  },
  pageDescription: {
    id: '',
    description: 'Page Description',
    defaultMessage:
      'Stir is the community for single parents to just be singles who happen to be parents. Join our app today and meet, chat and date with other single moms and dads around you.',
  },
  pageKeywords: {
    id: '',
    description: 'Page keywords',
    defaultMessage:
      'date single parent meet chat match mom dad kids up social divorced widow widower local',
  },
});

export default seo;
